/**
 * Levenshtein distance algorithm: calculates edit distance between two strings
 * Used to measure voice recognition accuracy
 */
function levenshtein(a, b) {
  const matrix = [];

  // Initialize rows
  for (let i = 0; i <= a.length; i += 1) {
    matrix[i] = [i];
  }

  // Initialize columns
  for (let j = 1; j <= b.length; j += 1) {
    matrix[0][j] = j;
  }

  // Fill in the matrix
  for (let i = 1; i <= a.length; i += 1) {
    for (let j = 1; j <= b.length; j += 1) {
      if (a[i - 1] === b[j - 1]) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j] + 1,     // deletion
          matrix[i][j - 1] + 1,     // insertion
          matrix[i - 1][j - 1] + 1  // substitution
        );
      }
    }
  }

  return matrix[a.length][b.length];
}

/**
 * Calculate voice similarity score (0-100)
 * Compares transcript (user's speech) against target word
 * 100 = exact match, 0 = completely different
 */
function voiceSimilarity(transcript, target) {
  const a = transcript.trim().toUpperCase();
  const b = target.trim().toUpperCase();
  const maxLen = Math.max(a.length, b.length);

  if (maxLen === 0) return 100; // both empty = match

  const distance = levenshtein(a, b);
  return Math.round((1 - distance / maxLen) * 100);
}

// Web Speech API support detection
const speechSupported = typeof window !== 'undefined' && ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window);
const ttsSupported = typeof window !== 'undefined' && 'speechSynthesis' in window;

// Voice activity constants
const MAX_VOICE_ATTEMPTS = 5;
const PASS_THRESHOLD = 60;

export {
  levenshtein,
  voiceSimilarity,
  speechSupported,
  ttsSupported,
  MAX_VOICE_ATTEMPTS,
  PASS_THRESHOLD,
};
